import React from 'react';
import { DatePickerInput } from '@leapeasy/ui-kit';

/**
 * Claim form date fields render inside the Layerbar panel (overflow: auto), which
 * clips the default inline calendar. Portal mode renders the picker on document.body.
 */
const ClaimDatePickerInput = (props) => <DatePickerInput portal {...props} />;

export default ClaimDatePickerInput;
